import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Label, Checkbox as SliceCheckBox } from 'pcln-design-system'

import Tooltip from '../Tooltip'

const CheckBoxContainer = styled.div`
  position: relative;
  margin-bottom: 12px;
  font-weight: 300;
`

class Checkbox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hover: false,
    }
  }

  toggleHover = () => {
    this.setState({ hover: !this.state.hover })
    this.props.onHover(!this.state.hover)
  }

  tooltipToggle = () => {
    if (!this.context.anySlicesFilteredFor && !this.props.hasNoHoverTooltipCookie) {
      return (
        <Tooltip
          data-test='slice-selection-tooltip'
          isHovered={this.state.hover}
          tooltipContent='Show all flights with this leg'
        />
      )
    }
    return null
  }

  selectCheckBox = (event) => {
    event.stopPropagation()
    this.props.checkAction()
  }

  render() {
    const { isChecked } = this.props

    /**
     * Checkbox eventPropgation is not working as expected. So a click event has to be used on
     * the parent label to stop the click Event propogation
     * */

    return (
      <CheckBoxContainer data-autobot-element='slice-selection-checkbox'>
        <Label
          onMouseEnter={this.toggleHover}
          onMouseLeave={this.toggleHover}
          onClick={this.selectCheckBox}
          data-autobot-element='slice-selection-checkbox-label'
        >
          <SliceCheckBox
            size={25}
            checked={isChecked}
            data-autobot-element='slice-selection-custom-checkbox'
          />
        </Label>
        {this.tooltipToggle()}
      </CheckBoxContainer>
    )
  }
}

Checkbox.propTypes = {
  onHover: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  checkAction: PropTypes.func.isRequired,
  hasNoHoverTooltipCookie: PropTypes.bool.isRequired,
}

Checkbox.contextTypes = {
  SETI: PropTypes.object,
  anySlicesFilteredFor: PropTypes.bool,
}

export default Checkbox
